module.exports = __webpack_public_path__ + "static/img/dialog_warning.0136d9d2.png";